var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{key:_vm.id,attrs:{"get-item":_vm.cachedGetItem,"set-item":_vm.setItem,"set-cache":_vm.setCache,"get-results":_vm.cachedGetResults}})
}
var staticRenderFns = []

export { render, staticRenderFns }